/* @flow */
import cx from 'classnames';
import React from 'react';

import './styles/DialogTitle.scss';

class DialogTitle extends React.Component {
  static propTypes = {
    text: React.PropTypes.string,
  };

  render() {
    return (
      <h2 {...this.props} className={cx('DialogTitle', this.props.className)}>
        {this.props.text}
        {this.props.children}
      </h2>
    );
  }
}

export default DialogTitle;



// WEBPACK FOOTER //
// ./src/components/DialogTitle.jsx